/*
 *   File : delete-modal.js
 *   Author : https://evoqins.com
 *   Description : Delete confirm modal
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import React, { memo, useEffect } from 'react';
import { PrimaryButton, SecondaryButton } from '../Buttons';

const DeleteModal = ({ handleClose, onConfirm }) => {

    // handle close Modal 
    const _handleCloseModal = () => {
        const button = document.getElementById("delete-field-modal-close");
        button?.click();
        handleClose();
    };

    return (
        <div className="modal fade" id="delete-field-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content e-border-radius-28 w-400px mx-auto">
                    <img
                        src={require("../../Assets/Images/Home/close.svg").default}
                        draggable={false}
                        className="d-none"
                        id="delete-field-modal-close"
                        alt="close"
                        data-bs-dismiss="modal"
                    />
                    <div className="modal-header px-4 pt-4 pb-3 border-0 align-items-start justify-content-end">
                        <img
                            src={require("../../Assets/Images/Home/close.svg").default}
                            draggable={false}
                            alt="close"
                            className="cursor-pointer"
                            onClick={_handleCloseModal}
                        />
                    </div>
                    <div className="modal-body px-4 pb-2 pt-0 text-center">
                        <h4 className="mb-3 e-primary-font e-text-raisin-black e-font-16 e-font-weight-500 line-height-28px">
                            Are you sure you want to delete this field?
                        </h4>

                        {/* Custom buttons */}
                        <div className="row row-cols-2 pt-2 mt-2 pb-3">
                            <div className="col">
                                <SecondaryButton
                                    name="Cancel"
                                    className="w-100"
                                    onPress={_handleCloseModal}
                                />
                            </div>
                            <div className="col">
                                <PrimaryButton
                                    name="Delete"
                                    className="w-100 e-bg-primary-blue"
                                    onPress={() => {
                                        _handleCloseModal();
                                        onConfirm(); // call parent confirm action
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

DeleteModal.defaultProps = {
    handleClose: () => {},
    onConfirm: () => {},
};

export default memo(DeleteModal);
